import axios from '@plugins/axios';

const CREDENTIALS = '/api/credentials';
const CREDENTIALS_GET = CREDENTIALS;

export const getCredentialsService = async () => {
  const response = await axios.get(CREDENTIALS_GET);
  return response;
};
